/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateKpiReportCommand } from '../../models/update-kpi-report-command';
import { UpdateKpiReportCommandResult } from '../../models/update-kpi-report-command-result';

export interface ApiKpiReportsUpdateKpiReportsPost$Plain$Params {
      body?: UpdateKpiReportCommand
}

export function apiKpiReportsUpdateKpiReportsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKpiReportsUpdateKpiReportsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateKpiReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsUpdateKpiReportsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateKpiReportCommandResult>;
    })
  );
}

apiKpiReportsUpdateKpiReportsPost$Plain.PATH = '/api/KPIReports/UpdateKPIReports';
